import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ITemplate } from "@/utils/Types";

interface TemplateState {
  templateStore: ITemplate;
  ctgStore: string;
  addCategory: (catg: string) => void;
  addTemplate: (template: ITemplate) => void;
}

const useTemplateStore = create<TemplateState>()(
  persist(
    (set) => ({
      templateStore: {} as ITemplate,
      ctgStore: "",
      addTemplate: (template) => set(() => ({ templateStore: template })),
      addCategory: (ctg) => set(() => ({ ctgStore: ctg })),
    }),
    {
      name: "template-storage",
      partialize: (state) => ({
        ctgStore: state.ctgStore,
      }),
    }
  )
);

export default useTemplateStore;
